import { maintaince } from '@/apis/maintaince';
import { MAINTAINCE } from '../mutation-types';

// export const state = {
// maintainceData: {
// subject: '',
// end_date: '',
// start_date: '',
// content: ''
// },
// maintaince: [],
// };
// export const getters = {
// maintainceData: state => state.maintainceData,
// maintaince: state => state.maintaince,
// };
export const mutations = {
  [MAINTAINCE.MAINTAINCE](state, data) {
    state.maintaince = data;
  }
};

export const actions = {
  async health({ commit }, data) {
    const res = await maintaince(data);
    if (res) {
      return res;
    }
    commit(MAINTAINCE.MAINTAINCE, res);
    return false;
  }
};
